import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/common/Button";
import { OtpInput } from "./components/OtpInput";
import { authService } from "@/api/services/auth.service";
import { mapAuthContactToUser } from "@/types/auth.types";
import { storage } from "@/utils/storage";
import { useAuth } from "@/context/AuthContext";
import { getHomeRoute } from "@/utils/navigation";
import styles from "./Otp.module.css";
export const Otp = () => {
    const navigate = useNavigate();
    const { login, user, isAuthenticated } = useAuth();
    const [otpFields, setOtpFields] = useState(["", "", "", "", "", ""]);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [email] = useState(storage.getEmail() || "");
    useEffect(() => {
        // Redirect if no email stored (came from direct URL)
        if (!email) {
            navigate("/login");
        }
    }, [email, navigate]);
    // Redirect if already authenticated
    useEffect(() => {
        if (isAuthenticated && user) {
            navigate(getHomeRoute(user.role), { replace: true });
        }
    }, [isAuthenticated, user, navigate]);
    const handleOtpChange = (index, value) => {
        const newFields = [...otpFields];
        newFields[index] = value;
        setOtpFields(newFields);
        setErrorMessage("");
    };
    const handleOtpPaste = (values) => {
        setOtpFields(values);
        setErrorMessage("");
    };
    const handleSubmit = async (e, otpValues) => {
        e?.preventDefault();
        // Use provided values if available (from auto-complete), otherwise use state
        const fieldsToUse = otpValues || otpFields;
        const otp = fieldsToUse.join("");
        if (otp.length !== 6) {
            setErrorMessage("Please enter all 6 digits");
            return;
        }
        setLoading(true);
        setErrorMessage("");
        try {
            const response = await authService.verifyOtp({ email, otp });
            if (response.data.success && response.data.token) {
                if (response.data.contact) {
                    const user = mapAuthContactToUser(response.data.contact);
                    login(response.data.token, user);
                    navigate(getHomeRoute(user.role), { replace: true });
                }
                else if (response.data.user) {
                    login(response.data.token, response.data.user);
                    navigate(getHomeRoute(response.data.user.role), { replace: true });
                }
                else {
                    setErrorMessage("Invalid response. Please try again.");
                }
            }
        }
        catch (error) {
            const message = error.response?.data?.message || "Invalid code. Please try again.";
            setErrorMessage(message);
            setOtpFields(["", "", "", "", "", ""]);
        }
        finally {
            setLoading(false);
        }
    };
    const handleResend = async () => {
        setSuccessMessage("");
        setErrorMessage("");
        try {
            const response = await authService.resendEmail(email);
            setSuccessMessage(response.data.message || "Code sent successfully!");
            setOtpFields(["", "", "", "", "", ""]);
        }
        catch (error) {
            const message = error.response?.data?.message ||
                "Failed to resend code. Please try again.";
            setErrorMessage(message);
        }
    };
    return (_jsx("div", { className: styles.container, style: { backgroundImage: `url(/images/bg-login.png)` }, children: _jsxs("div", { className: styles.content, children: [_jsx("div", { className: styles.brandPanel, children: _jsx("img", { src: "/images/logo-login.png", alt: "Defit Group logo" }) }), _jsxs("div", { children: [_jsx("div", { className: styles.formWrapperOuter, children: _jsxs("div", { className: styles.formWrapper, children: [_jsxs("div", { children: [_jsx("h2", { children: "Enter Code" }), _jsx("h3", { children: "Verify Your Identity" })] }), errorMessage && (_jsx("small", { className: styles.errorMessage, children: errorMessage })), successMessage && (_jsx("small", { className: styles.successMessage, children: successMessage })), !errorMessage && !successMessage && (_jsxs("small", { children: ["We sent a six-digit code to ", _jsx("strong", { children: email })] })), _jsxs("form", { className: styles.otpForm, onSubmit: handleSubmit, children: [_jsx(OtpInput, { fields: otpFields, onChange: handleOtpChange, onPaste: handleOtpPaste, onComplete: (values) => handleSubmit(undefined, values) }), _jsx(Button, { type: "submit", loading: loading, children: "Sign In" }), _jsxs("span", { className: styles.messageResend, children: ["Didn't receive a code?", " ", _jsx("a", { onClick: handleResend, children: "Resend Code" })] })] })] }) }), _jsx("p", { className: styles.termsText, children: "Terms & Conditions | Privacy Policy" })] })] }) }));
};
